/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SettingsKey {
    Billing = "Billing",
    LiabilityAppraiser = "LiabilityAppraiser",
    Meridian = "Meridian",
    TenantFile = "TenantFile",
    LoanSettings = "LoanSettings",
    InstitutionValueAdjuster = "InstitutionValueAdjuster",
    TransUnionCreditBureau = "TransUnionCreditBureau",
    Feature = "Feature",
    Sales = "Sales",
}
